import { FormattedMessage } from "react-intl"

const Content01 = () => {
    return (
        <div className="col-span-5 w-full max-w-6xl mx-auto px-4 pt-10 text-[#FFFFFF] sm:pl-16 lg:col-span-3 lg:pt-20 xl:pl-44 2xl:pl-36">
            <div className="text-6xl font-semibold bg-gradient-to-b from-white to-[#5AE65E] bg-clip-text text-transparent">
                01.
            </div>
            <div className="mt-4 text-xl font-bold sm:text-2xl md:text-3xl">
                <FormattedMessage id="LANDINGPAGE.BENEFITS_1_TITLE"/>
            </div>

            <div className="flex items-center justify-start py-4">
                <div className="flex items-center">
                    <div className="h-[1px] w-20 bg-[#5AE65E]"></div>
                    <div
                        className="w-1 h-1 bg-[#5AE65E]"
                        style={{
                            clipPath:
                                'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)',
                        }}
                    ></div>
                </div>
            </div>

            <div className="mb-8 text-base font-normal text-[#BEBEBE]">
                <FormattedMessage id="LANDINGPAGE.BENEFITS_1_SUBTITLE"/>
            </div>

            <div className="space-y-6 text-base text-white sm:pr-8 lg:text-sm xl:pr-20 xl:text-xs 2xl:text-sm">
                {[
                    {
                        titleKey: 'LANDINGPAGE.BENEFITS_1_FEATURE1_TITLE',
                        descKey: 'LANDINGPAGE.BENEFITS_1_FEATURE1_DESC',
                    },
                    {
                        titleKey: 'LANDINGPAGE.BENEFITS_1_FEATURE2_TITLE',
                        descKey: 'LANDINGPAGE.BENEFITS_1_FEATURE2_DESC',
                    },
                    {
                        titleKey: 'LANDINGPAGE.BENEFITS_1_FEATURE3_TITLE',
                        descKey: 'LANDINGPAGE.BENEFITS_1_FEATURE3_DESC',
                    },
                    {
                        titleKey: 'LANDINGPAGE.BENEFITS_1_FEATURE4_TITLE',
                        descKey: 'LANDINGPAGE.BENEFITS_1_FEATURE4_DESC',
                    },
                    {
                        titleKey: 'LANDINGPAGE.BENEFITS_1_FEATURE5_TITLE',
                        descKey: 'LANDINGPAGE.BENEFITS_1_FEATURE5_DESC',
                    },
                    {
                        titleKey: 'LANDINGPAGE.BENEFITS_1_FEATURE6_TITLE',
                        descKey: 'LANDINGPAGE.BENEFITS_1_FEATURE6_DESC',
                    },
                    {
                        titleKey: 'LANDINGPAGE.BENEFITS_1_FEATURE7_TITLE',
                        descKey: 'LANDINGPAGE.BENEFITS_1_FEATURE7_DESC',
                    },
                ].map((item, index) => (
                    <div key={index} className="flex items-start gap-2">
                        <img
                            src="/media/images/icon/checked.png"
                            alt="checked"
                            className="w-5 h-5"
                        />
                        <div>
                            <div className="font-medium">
                                <span className="font-bold">
                                    <FormattedMessage id={item.titleKey}/>
                                </span>{' '}
                                <FormattedMessage id={item.descKey}/>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Content01
